



























































































































































import Vue from 'vue';
import draggable from 'vuedraggable';
import html2canvas from 'html2canvas';
import AirbaseTarget from '@/components/airbase/AirbaseTarget.vue';
import EnemyFleetComponent from '@/components/enemy/EnemyFleet.vue';
import EnemyList from '@/components/enemy/EnemyList.vue';
import WorldList from '@/components/map/WorldList.vue';
import ItemList from '@/components/item/ItemList.vue';
import EnemyMaster from '@/classes/enemy/enemyMaster';
import BattleInfo, { BattleInfoBuilder } from '@/classes/enemy/battleInfo';
import AirbaseInfo from '@/classes/airbase/airbaseInfo';
import ItemMaster from '@/classes/item/itemMaster';
import Enemy from '@/classes/enemy/enemy';
import EnemyFleet, { EnemyFleetBuilder } from '@/classes/enemy/enemyFleet';
import CommonCalc from '@/classes/commonCalc';
import { AB_MODE } from '@/classes/const';
import Convert from '@/classes/convert';

const BattleCountItems = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

export default Vue.extend({
  name: 'EnemyFleetAll',
  components: {
    draggable,
    EnemyFleetComponent,
    EnemyList,
    WorldList,
    ItemList,
    AirbaseTarget,
  },
  props: {
    value: {
      type: BattleInfo,
      required: true,
    },
    airbaseInfo: {
      type: AirbaseInfo,
      required: true,
    },
    isDefense: {
      type: Boolean,
      required: true,
    },
    handleMinimize: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    items: BattleCountItems,
    enemyListDialog: false,
    itemListDialog: false,
    worldListDialog: false,
    targetDialog: false,
    dialogTarget: [-1, -1],
    itemDialogTarget: [-1, -1, -1],
    fleetStock: [] as EnemyFleet[],
    itemDialogWidth: 1200,
    capturing: false,
    alertAirbaseTarget: false,
  }),
  computed: {
    battleInfo(): BattleInfo {
      return this.value;
    },
    nodeString(): string {
      const nodeList = this.value.fleets.map((v) => v.nodeName);
      if (nodeList.some((v) => v !== '')) {
        let map = '';
        const lastBattle = this.value.fleets[this.value.fleets.length - 1];
        if (lastBattle && lastBattle.area) {
          const world = Math.floor(lastBattle.area / 10);
          map = `${world > 40 ? 'E' : world}-${lastBattle.area % 10}`;
        }
        return `${map} : ${nodeList.map((v) => (v === '' ? '?' : v)).join(' → ')}`;
      }
      return '';
    },
    defenseAirPowerBorders(): number[] {
      if (this.isDefense) {
        return CommonCalc.getAirStatusBorder(this.battleInfo.airRaidFleet.airbaseAirPower);
      }
      return [];
    },
    existsBattleAirbase(): boolean {
      return this.airbaseInfo.airbases.some((v) => v.mode === AB_MODE.BATTLE);
    },
    airbaseTargetButtonColor(): string {
      return this.alertAirbaseTarget ? 'error' : 'success';
    },
  },
  methods: {
    setInfo(builder = undefined as BattleInfoBuilder | undefined) {
      let newBattleInfo: BattleInfo;
      if (builder) {
        newBattleInfo = new BattleInfo(builder);
      } else {
        newBattleInfo = new BattleInfo({ info: this.battleInfo });
      }
      // 基地派遣先の整合性チェック
      const { airbases } = this.airbaseInfo;
      for (let i = 0; i < airbases.length; i += 1) {
        const targets = airbases[i].battleTarget;
        for (let j = 0; j < targets.length; j += 1) {
          const target = targets[j];
          if (target >= newBattleInfo.battleCount) {
            targets[j] = newBattleInfo.battleCount - 1;
          }
        }
      }
      this.$emit('input', newBattleInfo);
    },
    async showItemList(fleetIndex: number, enemyIndex: number, slotIndex: number) {
      this.itemDialogTarget = [fleetIndex, enemyIndex, slotIndex];
      const enemy = this.battleInfo.fleets[fleetIndex].enemies[enemyIndex];
      await (this.itemListDialog = true);
      (this.$refs.itemList as InstanceType<typeof ItemList>).initialFilter(enemy, slotIndex);
    },
    showEnemyList(battle: number, index: number) {
      this.dialogTarget = [battle, index];
      this.enemyListDialog = true;
    },
    async showWorldListContinuous() {
      this.fleetStock = [];
      await (this.worldListDialog = true);
      const ref = this.$refs.worldList as InstanceType<typeof WorldList>;
      ref.continuousMode = true;
      ref.selectedNodeName = '';
      ref.selectedNodeNames = [];
      ref.snackbar = false;
    },
    async showWorldList(index: number) {
      this.fleetStock = [];
      this.dialogTarget = [index, 0];
      await (this.worldListDialog = true);
      const ref = this.$refs.worldList as InstanceType<typeof WorldList>;
      ref.continuousMode = false;
      ref.selectedNodeName = '';
      ref.selectedNodeNames = [];
      ref.snackbar = false;
      if (ref.allCells.length) {
        ref.cellChanged();
      }
    },
    putEnemy(enemy: EnemyMaster) {
      this.enemyListDialog = false;
      const fleetIndex = this.dialogTarget[0];
      const index = this.dialogTarget[1];
      const fleet = this.isDefense ? this.battleInfo.airRaidFleet : this.battleInfo.fleets[fleetIndex];

      // マスタから敵艦を解決
      const masterEnemies = this.$store.getters.getEnemies as EnemyMaster[];
      const masterEnemy = masterEnemies.find((v) => v.id === enemy.id);
      if (!masterEnemy) {
        return;
      }

      // 装備マスタより装備を解決
      const allItems = this.$store.state.items as ItemMaster[];
      // 6隻目以降なら連合随伴とする
      const isEscort = fleet.isUnion && index >= 6;
      const newEnemy = Enemy.createEnemyFromMaster(masterEnemy, isEscort, allItems);
      const enemies = fleet.enemies.concat();
      enemies[index] = newEnemy;
      const builder: EnemyFleetBuilder = { fleet, enemies };

      // 敵編成が更新されたため、敵艦隊を再インスタンス化し更新
      if (this.isDefense) {
        // 空襲モード用敵編成に追加 それ以外は据え置き
        this.setInfo({ info: this.battleInfo, airRaidFleet: new EnemyFleet(builder) });
      } else {
        this.battleInfo.fleets[fleetIndex] = new EnemyFleet(builder);
        this.setInfo();
      }
    },
    equipItem(item: ItemMaster) {
      console.log(item);
      console.log(this.itemDialogTarget);
    },
    setEnemyFleet(fleet: EnemyFleet, isContinue = false) {
      if (fleet.nodeName === 'Air Raid' || this.isDefense) {
        this.airbaseInfo.isDefense = true;
        // 空襲モード用敵編成に追加して終了
        this.setInfo({ info: this.battleInfo, airRaidFleet: fleet });
        this.worldListDialog = false;
      } else if (isContinue && this.fleetStock.length < 9) {
        this.fleetStock.push(fleet);
      } else if (isContinue) {
        // 10制限 閉じる
        this.fleetStock.push(fleet);
        this.closeWorldList();
      } else {
        const index = this.dialogTarget[0];
        this.battleInfo.fleets[index] = new EnemyFleet({ fleet });
        this.setInfo();
        this.worldListDialog = false;
      }
    },
    closeWorldList() {
      this.worldListDialog = false;
      this.toggleWorldList();
    },
    closeEnemyList() {
      this.enemyListDialog = false;
    },
    toggleWorldList() {
      if (!this.worldListDialog && this.fleetStock.length) {
        // 連続入力モード データがあればそれを登録
        const battleCount = this.fleetStock.length;
        const builder: BattleInfoBuilder = {
          info: this.battleInfo,
          fleets: this.fleetStock,
          battleCount,
        };

        // setInfoによって更新されてしまう前に退避
        const prevBattleCount = this.battleInfo.battleCount;
        this.setInfo(builder);

        // 戦闘回数がsetInfoによる更新前後で変わっていたら基地ターゲットにアラートを出す
        if (battleCount > 1 && prevBattleCount !== battleCount && this.existsBattleAirbase) {
          this.alertAirbaseTarget = true;
        }
      }
    },
    resetFleetAll() {
      if (this.isDefense) {
        this.setInfo({ info: this.battleInfo, airRaidFleet: new EnemyFleet() });
      } else {
        this.setInfo({ info: this.battleInfo, fleets: [], battleCount: 1 });
      }
    },
    toggleTargetDialog() {
      if (!this.targetDialog) {
        this.alertAirbaseTarget = false;
        this.setInfo();
      }
    },
    closeTargetDialog() {
      this.targetDialog = false;
      this.setInfo();
    },
    closeItemList() {
      this.itemListDialog = false;
    },
    changeWidth(width: number) {
      this.itemDialogWidth = width;
    },
    captureEnemy() {
      // 背景色とかを塗るフラグ立て
      this.capturing = true;
      const div = document.getElementById('enemies-container') as HTMLDivElement;
      setTimeout(() => {
        html2canvas(div, { scale: 2, width: 1160 }).then((canvas) => {
          const link = document.createElement('a');
          link.href = canvas.toDataURL();
          link.download = `enemy_${Convert.formatDate(new Date(), 'yyyyMMdd-HHmmss')}.jpg`;
          link.click();
          this.capturing = false;
        });
      }, 10);
    },
  },
});
